function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { mapMutations, mapState } from 'vuex';
import tasks from '@/js/tasks';
import PartitionValidationErrors from '@/apps/attributes/modules/use_cases/components/PartitionValidationErrors';
import { extractCreateTables, extractReferencedTables, buildRewrites, buildReferencedTablesPayload, applyRewrites } from '@/apps/attributes/utils/sql_parser';
export default {
  name: 'CreateAttributeForm',
  components: {
    PartitionValidationErrors: PartitionValidationErrors
  },
  props: {
    existingTableNames: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      valid: false,
      currentStep: 1,
      isDragging: false,
      loadingUseCases: false,
      sending: false,
      useCases: [],
      // Nueva automatización: solo 1 período permitido al crear.
      // El resto de meses se cargan después vía "Cargar meses" (hasta 6).
      maxChips: 1,
      selectedMonth: null,
      selectedYear: null,
      chips: [],
      chipsError: false,
      parseErrors: [],
      partitionValidation: null,
      parsedSqlText: '',
      createRewrites: new Map(),
      referencedRewrites: new Map(),
      createTablePreview: [],
      referencedTablePreview: [],
      referencedTablesRaw: [],
      form: {
        script_file: null,
        use_case: null,
        table_description: '',
        nombre_tabla: ''
      },
      rules: {
        file: [function (v) {
          return !!v || _this.$t('create_attribute.rules.file_required');
        }, function (v) {
          return !v || v.size < 5000000 || _this.$t('create_attribute.rules.file_size');
        }],
        use_case: [function (v) {
          return !!v || _this.$t('create_attribute.rules.use_case_required');
        }],
        table_description: [function (v) {
          return !!(v && v.trim()) || _this.$t('create_attribute.rules.description_required');
        }, function (v) {
          return !v || v.length <= 500 || _this.$t('create_attribute.rules.description_max_length');
        }],
        nombre_tabla: [function (v) {
          return !!v || _this.$t('create_attribute.rules.nombre_tabla_required');
        }, function (v) {
          return /^[a-z][a-z0-9_]{1,48}$/.test(v) || _this.$t('create_attribute.rules.nombre_tabla_format');
        }, function (v) {
          return !v || !_this.existingTableNames.includes(('sand_ibk_attr_' + v).toLowerCase()) || _this.$t('create_attribute.rules.nombre_tabla_duplicate');
        }]
      },
      months: [{
        name: 'Enero',
        value: '01'
      }, {
        name: 'Febrero',
        value: '02'
      }, {
        name: 'Marzo',
        value: '03'
      }, {
        name: 'Abril',
        value: '04'
      }, {
        name: 'Mayo',
        value: '05'
      }, {
        name: 'Junio',
        value: '06'
      }, {
        name: 'Julio',
        value: '07'
      }, {
        name: 'Agosto',
        value: '08'
      }, {
        name: 'Septiembre',
        value: '09'
      }, {
        name: 'Octubre',
        value: '10'
      }, {
        name: 'Noviembre',
        value: '11'
      }, {
        name: 'Diciembre',
        value: '12'
      }]
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('attribute', ['businessUserServiceAccounts'])), mapState('data-platform', ['companyCode'])), {}, {
    years: function years() {
      var currentYear = new Date().getFullYear();
      var years = [];
      for (var i = 0; i < 5; i++) {
        var year = currentYear - i;
        years.push({
          name: year.toString(),
          value: year.toString()
        });
      }
      return years;
    },
    dbReadNames: function dbReadNames() {
      return (this.businessUserServiceAccounts || []).map(function (u) {
        return u.db_read_name;
      }).filter(Boolean);
    },
    isFormValid: function isFormValid() {
      var desc = (this.form.table_description || '').trim();
      var nombre = this.form.nombre_tabla || '';
      var file = this.form.script_file;
      return !!this.form.use_case && /^[a-z][a-z0-9_]{1,48}$/.test(nombre) && !this.existingTableNames.includes(('sand_ibk_attr_' + nombre).toLowerCase()) && desc.length > 0 && desc.length <= 500 && !!file && file.size < 5000000 && this.chips.length > 0 && this.parseErrors.length === 0 && !this.partitionValidation;
    }
  }),
  watch: {
    chips: function chips() {
      if (this.chips.length > 0) this.chipsError = false;
    },
    currentStep: function currentStep(val) {
      this.$emit('step-changed', val);
    },
    businessUserServiceAccounts: function businessUserServiceAccounts() {
      if (this.form.script_file && this.parsedSqlText) {
        this.reparseFromText(this.parsedSqlText);
      }
    },
    isFormValid: {
      immediate: true,
      handler: function handler(val) {
        this.$emit('validity-changed', val);
      }
    }
  },
  mounted: function mounted() {
    this.fetchUseCases();
    if (!this.businessUserServiceAccounts || this.businessUserServiceAccounts.length === 0) {
      this.$store.dispatch('attribute/getBusinessUserServiceAccounts', this.companyCode);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    fetchUseCases: function fetchUseCases() {
      var _this2 = this;
      this.loadingUseCases = true;
      var params = {
        user: window.userInfo.email
      };
      UseCasesService.getOwnerUseCasesByStatus('3', params).then(function (response) {
        _this2.useCases = response.data && response.data.records || [];
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
      }).finally(function () {
        _this2.loadingUseCases = false;
      });
    },
    addChip: function addChip() {
      var _this3 = this;
      if (!this.selectedMonth || !this.selectedYear) return;
      if (this.chips.length >= this.maxChips) {
        tasks.toast.info(this.$t('create_attribute.rules.max_periods', {
          max: this.maxChips
        }));
        return;
      }
      var id = "".concat(this.selectedYear, "-").concat(this.selectedMonth, "-01");
      if (this.chips.find(function (c) {
        return c.id === id;
      })) {
        tasks.toast.info(this.$t('create_attribute.rules.period_duplicate'));
        return;
      }
      var monthMatch = this.months.find(function (m) {
        return m.value === _this3.selectedMonth;
      });
      var monthName = monthMatch ? monthMatch.name : this.selectedMonth;
      this.chips.push({
        id: id,
        display: "".concat(monthName, " ").concat(this.selectedYear)
      });
    },
    removeChip: function removeChip(index) {
      this.chips.splice(index, 1);
    },
    readFileAsBase64: function readFileAsBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          return resolve(reader.result.split(',')[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    readFileAsText: function readFileAsText(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    parseAndPreview: function () {
      var _parseAndPreview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
        var sqlText;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.parseErrors = [];
              this.partitionValidation = null;
              this.createRewrites = new Map();
              this.referencedRewrites = new Map();
              this.createTablePreview = [];
              this.referencedTablePreview = [];
              this.parsedSqlText = '';
              if (!(!this.businessUserServiceAccounts || this.businessUserServiceAccounts.length === 0)) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.$store.dispatch('attribute/getBusinessUserServiceAccounts', this.companyCode);
            case 1:
              _context.n = 2;
              return this.readFileAsText(file);
            case 2:
              sqlText = _context.v;
              this.parsedSqlText = sqlText;
              this.reparseFromText(sqlText);
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function parseAndPreview(_x) {
        return _parseAndPreview.apply(this, arguments);
      }
      return parseAndPreview;
    }(),
    reparseFromText: function reparseFromText(sqlText) {
      var createTables = extractCreateTables(sqlText);
      var referencedTables = extractReferencedTables(sqlText);
      var _buildRewrites = buildRewrites(createTables, referencedTables, this.dbReadNames),
        createTableRewrites = _buildRewrites.createTableRewrites,
        referencedRewrites = _buildRewrites.referencedRewrites,
        errors = _buildRewrites.errors;
      this.parseErrors = errors;
      this.createRewrites = createTableRewrites;
      this.referencedRewrites = referencedRewrites;
      this.referencedTablesRaw = referencedTables.map(function (r) {
        return {
          dataset: r.dataset,
          table: r.table
        };
      });
      this.createTablePreview = createTables.map(function (ct) {
        var dsKey = (ct.originalDataset || '').toLowerCase();
        var key = "".concat(dsKey, ".").concat(ct.originalTable.toLowerCase());
        var rewrite = createTableRewrites.get(key);
        var originalDisplay = ct.originalDataset ? "".concat(ct.originalDataset, ".").concat(ct.originalTable) : ct.originalTable;
        return {
          original: ct.originalTable,
          originalDataset: ct.originalDataset,
          final: rewrite ? "".concat(rewrite.newDataset, ".").concat(rewrite.newTable) : "".concat(originalDisplay, " (error \u2014 ver arriba)")
        };
      });
      this.referencedTablePreview = referencedTables.map(function (ref) {
        var key = "".concat(ref.dataset.toLowerCase(), ".").concat(ref.table.toLowerCase());
        var rewrite = referencedRewrites.get(key);
        return {
          original: "".concat(ref.dataset, ".").concat(ref.table),
          rlink: !!rewrite,
          final: rewrite ? "".concat(rewrite.newDataset, ".").concat(rewrite.newTable) : "".concat(ref.dataset, ".").concat(ref.table)
        };
      });
    },
    dropFile: function dropFile(e) {
      this.isDragging = false;
      var files = e.dataTransfer.files;
      if (files.length > 0) {
        var file = files[0];
        if (file.name.toLowerCase().endsWith('.sql')) {
          this.form.script_file = file;
        } else {
          tasks.toast.error(this.$t('create_attribute.errors.invalid_file_type'));
        }
      }
    },
    onFileSelected: function onFileSelected() {
      this.isDragging = false;
      this.parseErrors = [];
      this.partitionValidation = null;
      this.createTablePreview = [];
      this.referencedTablePreview = [];
      this.referencedTablesRaw = [];
      this.parsedSqlText = '';
    },
    validate: function validate() {
      var formValid = this.$refs.form.validate();
      if (this.chips.length === 0) {
        this.chipsError = true;
        return false;
      }
      this.chipsError = false;
      return formValid;
    },
    resetValidation: function resetValidation() {
      this.$refs.form.resetValidation();
      this.chipsError = false;
    },
    reset: function reset() {
      this.$refs.form.reset();
      this.form = {
        script_file: null,
        use_case: null,
        table_description: '',
        nombre_tabla: ''
      };
      this.chips = [];
      this.selectedMonth = null;
      this.selectedYear = null;
      this.chipsError = false;
      this.currentStep = 1;
      this.parseErrors = [];
      this.partitionValidation = null;
      this.createTablePreview = [];
      this.referencedTablePreview = [];
      this.referencedTablesRaw = [];
      this.parsedSqlText = '';
      this.createRewrites = new Map();
      this.referencedRewrites = new Map();
    },
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.validate()) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (this.form.script_file) {
                _context2.n = 2;
                break;
              }
              tasks.toast.error(this.$t('create_attribute.rules.file_required'));
              return _context2.a(2);
            case 2:
              if (!(this.form.script_file.size >= 5000000)) {
                _context2.n = 3;
                break;
              }
              tasks.toast.error(this.$t('create_attribute.rules.file_size'));
              return _context2.a(2);
            case 3:
              this.setShowLoading(true);
              _context2.p = 4;
              _context2.n = 5;
              return this.parseAndPreview(this.form.script_file);
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t = _context2.v;
              console.error(_t);
              tasks.toast.error(this.translate('error_messages.error_general'), this.translate('titles.error'));
              this.setShowLoading(false);
              return _context2.a(2);
            case 7:
              this.setShowLoading(false);
              if (!(this.parseErrors.length > 0)) {
                _context2.n = 8;
                break;
              }
              return _context2.a(2);
            case 8:
              _context2.n = 9;
              return this.confirmAndSend();
            case 9:
              return _context2.a(2);
          }
        }, _callee2, this, [[4, 6]]);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }(),
    confirmAndSend: function () {
      var _confirmAndSend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this4 = this;
        var SEND_TIMEOUT_MS, safetyTimer, transformedSql, referencedTablesRewritten, fileBase64, data, result, payload, status, respData, partitionVal, backendMessage, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!this.sending) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.sending = true;
              this.$emit('sending-changed', true);
              this.setShowLoading(true);
              // Fase 9: timeout duro para que el spinner global no se cuelgue si la red queda colgada.
              SEND_TIMEOUT_MS = 180000;
              safetyTimer = setTimeout(function () {
                if (_this4.sending) {
                  _this4.sending = false;
                  _this4.$emit('sending-changed', false);
                  _this4.setShowLoading(false);
                  tasks.toast.error(_this4.translate('create_attribute.errors.timeout'), _this4.translate('titles.error'));
                }
              }, SEND_TIMEOUT_MS);
              _context3.p = 2;
              transformedSql = applyRewrites(this.parsedSqlText, this.createRewrites, this.referencedRewrites);
              referencedTablesRewritten = buildReferencedTablesPayload(this.referencedRewrites);
              fileBase64 = btoa(unescape(encodeURIComponent(transformedSql)));
              data = {
                script_file: fileBase64,
                script_name: this.form.script_file.name,
                periods: this.chips.map(function (chip) {
                  return chip.id;
                }),
                use_case_id: this.form.use_case ? this.form.use_case.id : null,
                use_case_name: this.form.use_case ? this.form.use_case.business_name : null,
                operator: window.userInfo.email,
                table_description: this.form.table_description || '',
                nombre_tabla: 'sand_ibk_attr_' + this.form.nombre_tabla,
                referenced_tables: referencedTablesRewritten
              };
              _context3.n = 3;
              return UseCasesService.createAttributeAutomation(data);
            case 3:
              result = _context3.v;
              payload = result && result.data || result || {};
              if (payload.pending_review === true) {
                // La IA de validación NO estuvo disponible (error de red / timeout / servicio caído):
                // el backend creó la automatización en estado "Solicitado" para revisión manual
                // sin invocar el pipeline. El padre cierra el form y muestra el diálogo
                // "Enviado a revisión". Si la IA encontró errores concretos, llega como 422 (ver catch).
                this.$emit('pending-review', {
                  result: result,
                  request: data
                });
              } else {
                this.$emit('saved', {
                  result: result,
                  request: data
                });
              }
              _context3.n = 6;
              break;
            case 4:
              _context3.p = 4;
              _t2 = _context3.v;
              status = _t2 && _t2.response && _t2.response.status;
              respData = _t2 && _t2.response && _t2.response.data || {};
              partitionVal = respData.data && respData.data.partition_validation; // Flujo primario de error de partición: la IA respondió y encontró filtros faltantes.
              // El backend retorna 422 con partition_validation; se muestran los errores inline
              // en el formulario para que el usuario corrija el SQL y vuelva a intentarlo.
              // (Si la IA no estaba disponible, el backend devuelve 200 con pending_review=true.)
              if (!(status === 422 && partitionVal && partitionVal.ok === false && Array.isArray(partitionVal.errors))) {
                _context3.n = 5;
                break;
              }
              // El panel inline (PartitionValidationErrors) muestra el detalle accionable
              // (tabla, línea, snippet, motivo y SQL sugerido). El toast es solo un aviso breve.
              this.partitionValidation = partitionVal;
              tasks.toast.error(this.$t('create_attribute.partition_validation.blocked'));
              return _context3.a(2);
            case 5:
              // Fase 9: mostrar mensaje del backend cuando es informativo (409 duplicado, 500 explícito, etc.)
              backendMessage = respData.message || respData.data && respData.data.message || respData.error;
              if (backendMessage) {
                tasks.toast.error(String(backendMessage), this.translate('titles.error'));
              } else {
                tasks.toast.error(this.translate('error_messages.error_general'), this.translate('titles.error'));
              }
              // Si el backend pudo haber dejado side-effects (p.ej. 5xx tras stagear DB) → pedir al padre que refresque
              // la tabla para que el zombie (si existe) sea visible. Idempotente: el padre decide cómo manejarlo.
              if (status >= 500) {
                this.$emit('error-with-side-effects', {
                  status: status,
                  message: backendMessage
                });
              }
              console.error(_t2);
            case 6:
              _context3.p = 6;
              clearTimeout(safetyTimer);
              this.sending = false;
              this.$emit('sending-changed', false);
              this.setShowLoading(false);
              return _context3.f(6);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4, 6, 7]]);
      }));
      function confirmAndSend() {
        return _confirmAndSend.apply(this, arguments);
      }
      return confirmAndSend;
    }()
  })
};